<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline">{{labels.applicant}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.appIntStat}}</v-subheader>
              <div>{{applicantStatus}}</div>
            </v-flex>
            <template v-if="applicant.appIntStat === 'E'">
              <v-flex lg6 xs12>
                <v-subheader class="queryLabel">{{labels.coyName}}</v-subheader>
                <div>{{applicant.coyName}}</div>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field v-model="motorForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'required|entry|max:20'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field v-model="motorForm.applicant.coyNature" :label="labels.coyNature" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.coyNature" v-validate="'entry|max:128'"></v-text-field>
              </v-flex>
            </template>
            <template v-else>
              <v-flex lg6 xs12>
                <v-autocomplete :items="salutationList" v-model="motorForm.applicant.appSalutation" :label="labels.appSalutation" item-text="label" item-value="value" data-vv-name="appSalutation" :data-vv-as="labels.appSalutation" :error-messages="errors.collect('appSalutation')" v-validate="'required'" @input="doSalutation"></v-autocomplete>
              </v-flex>
              <v-flex lg6 xs12>
                <v-subheader class="queryLabel">{{labels.appName}}</v-subheader>
                <div>{{applicant.appName}}</div>
              </v-flex>
              <template v-if="applicant.appIsDrv === true">
                <v-flex lg6 xs12>
                  <v-subheader class="queryLabel">{{labels.appNricPassport}}</v-subheader>
                  <div>{{applicant.appNricPassport}}</div>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-subheader class="queryLabel">{{labels.appDob}}</v-subheader>
                  <div>{{formatDisplayDate(applicant.appDob)}}</div>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-subheader class="queryLabel">{{labels.appGender}}</v-subheader>
                  <div>{{gender}}</div>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="motorForm.applicant.appOccupation" :label="labels.appOccupation" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.appOccupation" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
              </template>
              <template v-else>
                <v-flex lg6 xs12>
                  <v-text-field v-uppercase="motorForm.applicant.appNricPassport" v-model="motorForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'required|alpha_num|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker v-model="motorForm.applicant.appDob" :label="labels.appDob" v-validate="'required'" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group v-model="motorForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender" v-validate="'required'">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="motorForm.applicant.appOccupation" :label="labels.appOccupation" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.appOccupation" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-subheader class="queryLabel">{{labels.appIsDrv}}</v-subheader>
                  <div>{{applicant.appIsDrv? 'Yes' : 'No'}}</div>
                </v-flex>
              </template>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.appContact}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" v-validate="{ required: (motorForm.applicant.appIntStat === 'I'), numeric: true }" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.appAddress}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.mailAddress}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-checkbox v-model="motorForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.mailAdd3" :label="labels.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="motorForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :readonly="motorForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" v-validate="'numeric'" :loading="mailPostalCodeLoading" @change="doMailAddress"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.mailAdd1" :label="labels.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'entry|max:30'" :readonly="motorForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.mailAdd2" :label="labels.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'entry|max:255'" :readonly="motorForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.applicant.mailAdd4" :label="labels.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="motorForm.applicant.mailAdd"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <h3 class="headline">{{labels.namedDrivers}}</h3>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click.prevent="doAddDriver">
          Add Driver
          <v-icon right>mdi-account-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table :headers="driverColumns" :items="motorForm.drivers" class="elevation-1" :no-data-text="noDataText" hide-actions>
        <template slot="items" slot-scope="props">
          <td>{{props.item.drvName}}</td>
          <td>{{props.item.drvNricPassport}}</td>
          <td>{{formatDisplayDate(props.item.drvDob)}}</td>
          <td>{{props.item.drvExp}}</td>
          <td>{{drvGender(props.item.drvGender)}}</td>
          <td v-if="$mode !== 'ecics'">{{drvOccupation(props.item.drvOccupation)}}</td>
          <td>{{drvMaritalStatus(props.item.drvMarital)}}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="!(props.index === 0 && applicant.appIntStat === 'I')" :query="false" :remove="!(props.index === 0 && applicant.appIntStat === 'I')" @remove="doRemoveDriver(props)" @review="doEditDriver(props)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="driverDialog" persistent max-width="800px" lazy>
      <v-card>
        <v-card-title>
          <div class="headline">
            Driver
          </div>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="driverDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <form data-vv-scope="drvForm">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field data-vv-scope="drvForm" v-model="driver.drvName" :label="labels.drvName" :error-messages="errors.collect('drvName')" data-vv-name="drvName" :data-vv-as="labels.drvName" v-validate="'required|name|max:128'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field data-vv-scope="drvForm" v-uppercase="driver.drvNricPassport" v-model="driver.drvNricPassport" :label="labels.drvNricPassport" :error-messages="errors.collect('drvNricPassport')" data-vv-name="drvNricPassport" :data-vv-as="labels.drvNricPassport" v-validate="'required|entry|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field data-vv-scope="drvForm" v-int-mask="{intScale: 3}" v-model="driver.drvExp" :label="labels.drvExp" :error-messages="errors.collect('drvExp')" data-vv-name="drvExp" :data-vv-as="labels.drvExp" v-validate="'required|numeric|max_value:999|min_value:0'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete data-vv-scope="drvForm" :items="maritalStatusList" v-model="driver.drvMarital" :label="labels.drvMarital" item-text="label" item-value="value" data-vv-name="drvMarital" :data-vv-as="labels.drvMarital" :error-messages="errors.collect('drvMarital')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group data-vv-scope="drvForm" v-model="driver.drvGender" row :label="labels.drvGender" :error-messages="errors.collect('drvGender')" data-vv-name="drvGender" :data-vv-as="labels.drvGender" v-validate="'required'">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12 v-if="$mode !== 'ecics'">
                  <v-radio-group data-vv-scope="drvForm" v-model="driver.drvOccupation" row :label="labels.drvOccupation" :error-messages="errors.collect('drvOccupation')" data-vv-name="drvOccupation" :data-vv-as="labels.drvOccupation" v-validate="'required'">
                    <v-radio v-for="occupation in drvOccupationList" :key="occupation.value" :label="occupation.label" :value="occupation.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker data-vv-scope="drvForm" v-model="driver.drvDob" :label="labels.drvDob" v-validate="'required'" :data-vv-as="labels.drvDob" data-vv-name="drvDob" :error-messages="errors.collect('drvDob')"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click.native="driverDialog = false">Cancel</v-btn>
          <v-btn color="primary" flat="flat" type="submit" @click="doSaveDriver">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import toDate from 'date-fns/toDate'
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_DRIVER } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { mtrOccupation } from '@/const/underwriting/motor'
import { salutation, gender, maritalStatus, applicantStatus } from '@/const/underwriting'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status',
        appName: 'Name as in NRIC/Passport*',
        appSalutation: 'Salutation*',
        appNricPassport: 'NRIC/Passport*',
        appDob: 'Date of Birth*',
        appGender: 'Gender*',
        appOccupation: 'Business/Profession',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        mailAdd: 'Same as Applicant Address',
        mailAdd1: 'Block/House No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailPostalCode: 'Postal Code',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company*',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business',
        appIsDrv: 'Is the Applicant driving?',
        namedDrivers: 'Named Drivers',
        drvName: 'Name as in NRIC/Passport*',
        drvNricPassport: 'NRIC/Passport*',
        drvDob: 'Date of Birth*',
        drvExp: 'Driving Experience*',
        drvGender: 'Gender*',
        drvOccupation: 'Occupation*',
        drvMarital: 'Marital Status*'
      },
      motorForm: {
        applicant: {
          appIntStat: undefined,
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appOccupation: undefined,
          appGender: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyRocUen: undefined,
          coyNature: undefined,
          appIsDrv: undefined
        },
        drivers: []
      },
      driver: {
        seq: undefined,
        drvName: undefined,
        drvNricPassport: undefined,
        drvDob: undefined,
        drvExp: undefined,
        drvGender: undefined,
        drvOccupation: undefined,
        drvMarital: undefined
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false,
      driverDialog: false
    }
  },
  computed: {
    driverColumns() {
      if (this.$mode !== 'ecics') {
        return [
          { text: 'Name', align: 'left', sortable: false, value: 'drvName' },
          { text: 'NRIC/Passport', sortable: false, value: 'drvNricPassport' },
          { text: 'Date of Birth', sortable: false, value: 'drvDob' },
          { text: 'Driving Experience', sortable: false, value: 'drvExp' },
          { text: 'Gender', sortable: false, value: 'drvGender' },
          { text: 'Occupation', sortable: false, value: 'drvOccupation' },
          { text: 'Marital Status', sortable: false, value: 'drvMarital' },
          TableConst.tableActionHeader
        ]
      } else {
        return [
          { text: 'Name', align: 'left', sortable: false, value: 'drvName' },
          { text: 'NRIC/Passport', sortable: false, value: 'drvNricPassport' },
          { text: 'Date of Birth', sortable: false, value: 'drvDob' },
          { text: 'Driving Experience', sortable: false, value: 'drvExp' },
          { text: 'Gender', sortable: false, value: 'drvGender' },
          { text: 'Marital Status', sortable: false, value: 'drvMarital' },
          TableConst.tableActionHeader
        ]
      }
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    globalMotorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    applicant() {
      return this.globalCommonForm.applicant
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    applicantStatus() {
      if (this.applicant.appIntStat) {
        return applicantStatus[this.applicant.appIntStat]
      } else {
        return ' - '
      }
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    drvOccupationList() {
      let result = []
      Object.keys(mtrOccupation).forEach(function (key) {
        const status = mtrOccupation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    gender() {
      if (this.applicant.appGender) {
        return gender[this.applicant.appGender]
      } else {
        return ' - '
      }
    }
  },
  watch: {
    'motorForm.applicant.appAdd1': function (value) {
      if (this.motorForm.applicant.mailAdd) {
        this.motorForm.applicant.mailAdd1 = value
      }
    },
    'motorForm.applicant.appAdd2': function (value) {
      if (this.motorForm.applicant.mailAdd) {
        this.motorForm.applicant.mailAdd2 = value
      }
    },
    'motorForm.applicant.appAdd3': function (value) {
      if (this.motorForm.applicant.mailAdd) {
        this.motorForm.applicant.mailAdd3 = value
      }
    },
    'motorForm.applicant.appAdd4': function (value) {
      if (this.motorForm.applicant.mailAdd) {
        this.motorForm.applicant.mailAdd4 = value
      }
    },
    'motorForm.applicant.appPostalCode': function (value) {
      if (this.motorForm.applicant.mailAdd) {
        this.motorForm.applicant.mailPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.motorForm.applicant.appIntStat = applicant.appIntStat
      this.motorForm.applicant.appSalutation = applicant.appSalutation
      this.motorForm.applicant.appName = applicant.appName
      this.motorForm.applicant.appGender = applicant.appGender
      this.motorForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.motorForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.motorForm.applicant.appOccupation = applicant.appOccupation
      this.motorForm.applicant.appEmail = applicant.appEmail
      this.motorForm.applicant.appMobileNo = applicant.appMobileNo
      this.motorForm.applicant.appTelNo1 = applicant.appTelNo1
      this.motorForm.applicant.appTelNo2 = applicant.appTelNo2
      this.motorForm.applicant.appPostalCode = applicant.appPostalCode
      this.motorForm.applicant.appAdd1 = applicant.appAdd1
      this.motorForm.applicant.appAdd2 = applicant.appAdd2
      this.motorForm.applicant.appAdd3 = applicant.appAdd3
      this.motorForm.applicant.appAdd4 = applicant.appAdd4
      this.motorForm.applicant.mailAdd = applicant.mailAdd
      this.motorForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.motorForm.applicant.mailAdd1 = applicant.mailAdd1
      this.motorForm.applicant.mailAdd2 = applicant.mailAdd2
      this.motorForm.applicant.mailAdd3 = applicant.mailAdd3
      this.motorForm.applicant.mailAdd4 = applicant.mailAdd4
      this.motorForm.applicant.coyName = applicant.coyName
      this.motorForm.applicant.coyRocUen = applicant.coyRocUen
      this.motorForm.applicant.coyNature = applicant.coyNature
      this.motorForm.applicant.appIsDrv = applicant.appIsDrv

      // Drivers
      this.motorForm.drivers = clone(this.globalMotorForm.drivers)
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    drvMaritalStatus(status) {
      return maritalStatus[status]
    },
    drvGender(xGender) {
      return gender[xGender]
    },
    drvOccupation(occupation) {
      return mtrOccupation[occupation]
    },
    doSalutation() {
      if (this.motorForm.applicant.appSalutation === 'MR') {
        this.motorForm.applicant.appGender = 'M'
      } else if (this.motorForm.applicant.appSalutation === 'MS' || this.motorForm.applicant.appSalutation === 'MDM' || this.motorForm.applicant.appSalutation === 'MRS') {
        this.motorForm.applicant.appGender = 'F'
      } else {
        if (!this.motorForm.applicant.appGender || this.motorForm.applicant.appGender === null) {
          this.motorForm.applicant.appGender = 'M'
        }
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.motorForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.motorForm.applicant.appAdd1 = data.add1
            this.motorForm.applicant.appAdd2 = data.add2
            this.motorForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.motorForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.motorForm.applicant.mailAdd1 = data.add1
            this.motorForm.applicant.mailAdd2 = data.add2
            this.motorForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.motorForm.applicant.mailAdd1 = this.motorForm.applicant.appAdd1
      this.motorForm.applicant.mailAdd2 = this.motorForm.applicant.appAdd2
      this.motorForm.applicant.mailAdd3 = this.motorForm.applicant.appAdd3
      this.motorForm.applicant.mailAdd4 = this.motorForm.applicant.appAdd4
      this.motorForm.applicant.mailPostalCode = this.motorForm.applicant.appPostalCode
    },
    doRemoveDriver(props) {
      if (props && props.index !== null) {
        this.motorForm.drivers.splice(props.index, 1)
      }
    },
    doEditDriver(props) {
      // Init the driver details
      this.driver.seq = props.index
      this.driver.drvName = props.item.drvName
      this.driver.drvNricPassport = props.item.drvNricPassport
      this.driver.drvDob = props.item.drvDob
      this.driver.drvExp = props.item.drvExp
      this.driver.drvGender = props.item.drvGender
      this.driver.drvOccupation = props.item.drvOccupation
      this.driver.drvMarital = props.item.drvMarital

      this.resetValidator()

      this.driverDialog = true
    },
    doAddDriver() {
      // Init the driver details
      this.driver.seq = undefined
      this.driver.drvName = undefined
      this.driver.drvNricPassport = undefined
      this.driver.drvDob = undefined
      this.driver.drvExp = undefined
      this.driver.drvGender = undefined
      this.driver.drvOccupation = undefined
      this.driver.drvMarital = undefined

      this.resetValidator()

      this.driverDialog = true
    },
    doSaveDriver() {
      this.resetMessages()
      this.$validator.validateAll('drvForm').then(result => {
        if (result) {
          if (this.driver.seq === undefined) {
            // New Driver
            // Check for duplicate ic
            const duplicate = this.motorForm.drivers.find(x => x.drvNricPassport === this.driver.drvNricPassport)
            if (duplicate) {
              this.$snotify.error('There are duplicate NRIC/Passport No.')
            } else {
              this.motorForm.drivers.push(clone(this.driver))
              this.driverDialog = false
            }
          } else {
            // Update Driver
            // Check for duplicate ic
            let valid = true
            for (let i = 0; i < this.motorForm.drivers.length; i++) {
              if (i !== this.driver.seq && this.motorForm.drivers[i].drvNricPassport === this.driver.drvNricPassport) {
                valid = false
                break
              }
            }
            if (valid) {
              this.$set(this.motorForm.drivers, this.driver.seq, clone(this.driver))
              this.driverDialog = false
            } else {
              this.$snotify.error('There are duplicate NRIC/Passport No.')
            }
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'motorProposal' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.motorForm.applicant.appMobileNo && this.motorForm.applicant.appMobileNo !== '') ||
            (this.motorForm.applicant.appTelNo1 && this.motorForm.applicant.appTelNo1 !== '') ||
            (this.motorForm.applicant.appTelNo2 && this.motorForm.applicant.appTelNo2 !== '')) {
            this.$store.commit(QUOTE_MOTOR_DRIVER, this.motorForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
            this.$router.push({ name: 'motorProposalVehicle' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      try {
        this.$store.commit(QUOTE_MOTOR_DRIVER, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin,
    TableConst.default
  ]
}
</script>

<style>
</style>
